import styled from 'styled-components';

import { Colors, ContentSpacing, breakpoint } from '@estee/elc-base-theme';
import { Subtitle2, Caption, Body2 } from '@estee/elc-typography';

import { inheritBaseFont } from '~theme/default-theme';

import IProduct from '~domain/entities/Product/IProduct';

const { space4, space8, space24 } = ContentSpacing;

export const Description = styled.div`
    width: 70%;
`;

export const ProductName = styled(Subtitle2)`
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: break-spaces;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-block-end: ${space8};

    ${breakpoint('desktop')`
        width: 100%;
    `};
    ${inheritBaseFont};
`;

export const ProductSub = styled(Body2)`
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: break-spaces;
    text-overflow: ellipsis;
    overflow: hidden;

    ${breakpoint('desktop')`
        width: 100%;
    `};
    ${inheritBaseFont};
`;

export const Size = styled(Caption)<Partial<IProduct>>`
    display: inline-block;
    padding-block: ${space4};
    ${inheritBaseFont};
`;

export const Shade = styled(Caption)<Partial<IProduct>>`
    align-items: center;
    display: flex;
    padding-block: ${space4};
    &::before {
        ${({ shadeCode }: Partial<IProduct>) => (shadeCode ? 'display: flex' : 'display: none')};
        content: '';
        align-items: center;
        border-radius: 50%;
        width: ${space24};
        height: ${space24};
        background: ${({ shadeCode }: Partial<IProduct>) => shadeCode};
        border: ${space4} solid ${Colors.white};
        outline: 0.5px solid ${Colors.primary300};
        margin-inline-end: ${space8};
    }
    ${inheritBaseFont};
`;

export const ProductLink = styled.a`
    text-decoration: none;
    display: flex;
    flex-direction: column;
    border-bottom: none;
    cursor: pointer;
    &:hover,
    &:focus {
        text-decoration: none;
    }
`;

export const ShadeSizeWrapper = styled.div`
    display: flex;
    ${breakpoint('desktop')`
        align-items: center;
    `};
`;

export const ProductDescriptionWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    padding-bottom: ${space8};
`;

export const ProductPoints = styled(Body2)`
    text-overflow: ellipsis;
    width: inherit;
    overflow: hidden;
    ${inheritBaseFont};
`;
